import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEditCustomBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.editCustomBadge,
  {
    mutationKey: ['editCustomBadge'],
  },
)
